<template>
  <div class="programList_themeItem" v-if="list">
    <CompProgramList
      :currCid="currCid"
      :currSid="currSid"
      :currThemeObj="currThemeObj"
      :data="list"
      :detailPathName="''"
      :chooseState="''"
      :themeClass="`onlyDisplay`"
      :viewMode="'shareAfterView'"
    ></CompProgramList>
  </div>
</template>

<script>
// 节目单 主题
import cup_base_data_mixin from '@mixins/cup_base_data'
import CompProgramList from '@components/commonPage/programList/comp_programList.vue'
export default {
  name: 'commonPage_programList_themeItem',
  mixins: [cup_base_data_mixin],
  components: {
    CompProgramList,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {
      list: null,
      //   list: [
      //     {
      //       competitionId: 201,
      //       seasonId: 2012023,
      //       phaseId: 1,
      //       roundNum: 39,
      //       groupCode: null,
      //       matchId: 1009240,
      //       matchNum: 383,
      //       matchName: '常规赛第39轮',
      //       matchDate: '19:35',
      //       matchDatetime: '2024-02-05 19:35:00',
      //       matchStatus: 1,
      //       matchStatusName: '未开始',
      //       homeId: 1009,
      //       homeName: '辽宁本钢',
      //       homeNameAbbr: null,
      //       homeLogo: null,
      //       homeFlag: null,
      //       homeScore: null,
      //       homeWins: null,
      //       homeLosses: null,
      //       awayId: 1001,
      //       awayName: '北京北汽',
      //       awayNameAbbr: null,
      //       awayLogo: null,
      //       awayFlag: null,
      //       awayScore: null,
      //       awayWins: null,
      //       awayLosses: null,
      //       currentPeriod: null,
      //       currentPeriodName: null,
      //       timeMinutes: null,
      //       timeSeconds: null,
      //       periodScore: [],
      //     },
      //   ],
    }
  },
  watch: {
    datas(newVal, oldVal) {
      if (
        newVal &&
        JSON.stringify(newVal.data.dataList) !==
          JSON.stringify(oldVal.data.dataList)
      ) {
        this.computedMatchList(newVal.data.dataList)
      }
    },
    immediate: false,
    deep: true,
  },
  created() {
    this.computedMatchList(this.datas.data.dataList)
  },
  methods: {
    computedMatchList(list) {
      console.debug('computedMatchList 11:', list)
      if (list && list.length > 0) {
        this.list = list.map((item) => {
          let newItem = item
          //   newItem.chooseId = item.programId
          //   newItem.isChooseFlag = false
          return newItem
        })
      } else {
        this.list = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.programList_themeItem {
  position: relative;
  padding: 0.347vw 0 0.533vw 0;
  width: 100%;
  height: 100%;
}
</style>
